import React, { FC } from 'react'
import Lottie from 'lottie-react'
import Container from 'react-bootstrap/Container'
import loader from '../../assets/customizations/logos/loader.json'

import './index.scss'

type LoaderProps = {
    message: string
}

const Loader: FC<LoaderProps> = ({ message }) => {
    return (
        <Container role="status" aria-live="polite" className='d-flex flex-column align-items-center text-center vh-100'>
            <Lottie loop animationData={loader} className='loader-container' />
            <div>
                {message}
            </div>
        </Container>
    )
}

export default Loader